import React, { useState, useEffect } from "react";
import { DynoItem } from "../DynoItem";

export const DynoList = ({
  dynosList,
  isContentPage,
  copyDynoCallback,
  deleteDynoCallback,
  shareCallback,
  modalTitle,
  updatDynoStatusCallback,
  isProductAdmin,
  publishStatus,
  shareStatusCallback,
  openContent
}) => {
  const [dynoes, setDynoes] = useState([]);

  useEffect(() => {
    setDynoes(dynosList);
  }, [dynosList]);

  return (
    <>
      {dynoes.map((dyno) => (
        <DynoItem
          key={dyno.id}
          dyno={dyno}
          isContentPage={isContentPage}
          copyDynoCallback={() => copyDynoCallback(dyno)}
          deleteDynoCallback={() => deleteDynoCallback(dyno)}
          shareCallback={() => shareCallback(dyno)}
          modalTitle={modalTitle}
          updatDynoStatusCallback={updatDynoStatusCallback}
          isProductAdmin={isProductAdmin}
          publishStatus={publishStatus}
          shareStatusCallback={() => shareStatusCallback(dyno)}
          openContent={openContent}
        />
      ))}
    </>
  );
};
